import { ResultsType } from 'enums'

import { getNextPaginatedPage, getPaginatedItems, useExportToCSV } from 'hooks/useExportToCSV'
import { getCsvColumns } from 'modules/requests/exportToCsvColumns'
import { getCsvName } from 'modules/requests/utils'
import { ResultsQueryKeys } from 'services/results/queryKeys'
import type { Result } from 'services/results/types'
import { getResultsVerificationV2 } from 'services/results/v2'
import type { GetResultsVerificationV2Response, ResultsVerificationV2Filters } from 'services/results/v2/types'

export const EXPORT_PAGE_SIZE = 1000

/**
 * Exports every export & access request matching the given filters as a CSV file. The
 * filters are the same ones the table is showing, so the file always mirrors what the
 * user has on screen rather than the unfiltered list.
 */
export const useExportRequestsToCSV = (filters: ResultsVerificationV2Filters) => {
  const resultType = filters.resultType ?? ResultsType.FilesFolders

  return useExportToCSV<Result, GetResultsVerificationV2Response>({
    queryKey: ResultsQueryKeys.AllResultsVerificationV2(filters),
    fetchPage: (page, signal) => {
      return getResultsVerificationV2({ ...filters, page, perPage: EXPORT_PAGE_SIZE }, { signal })
    },
    getPageItems: getPaginatedItems,
    getNextPage: getNextPaginatedPage,
    columns: getCsvColumns(resultType),
    fileName: getCsvName(resultType)
  })
}
